import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";

interface ModalProps {
  children: React.ReactNode;
}

const modalRoot = document.getElementById("modal-root");

const Modal: React.FC<ModalProps> = ({ children }) => {
  const dispatch = useDispatch();
  const popUp = useSelector((state: RootState) => state.utils.popUp);
  const elRef = useRef<HTMLDivElement | null>(null);

  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  useEffect(() => {
    if (modalRoot && elRef.current) {
      modalRoot.appendChild(elRef.current);
    }

    // // Open the popup when the modal is mounted
    // if (!popUpOpen) {
    //   dispatch(togglePopup());
    // }

    return () => {
      if (modalRoot && elRef.current) {
        modalRoot.removeChild(elRef.current);
      }
    };
  }, [dispatch]);

  return popUp.open
    ? ReactDOM.createPortal(<>{children}</>, elRef.current)
    : null;
};

export default Modal;
